import React, { useEffect } from 'react';
import { Login } from './auth/login';
import awsConfig from './aws-config';
import { Amplify, API , Auth } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { API_NAME } from './common/constant';
import "../src/NewUi.css"
import "../src/App.css"
import Home from './pages/maintems2page/home';
import { useState } from 'react';
import { Spin, Result, Button } from 'antd';

Amplify.configure(awsConfig);

function App() {
  const { user } = useAuthenticator();
  const [userRoleName, setUserRoleName] = useState();
  const [apiResponse, setApiResponse] = useState(false);

  if (user) {
    return <Home />
  } else if (user && userRoleName !== 'Marketing Demo' && apiResponse) {
    return <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this portal."
      extra={<Button type="primary" onClick={async () => {
        await Auth.signOut();
        window.location.reload();
      }}> Back to login </Button>}
    />;
  } else if (!user) {
    return <Login />
  }
  else {
    return <Spin />
  }
}

export default App;
